import { render, staticRenderFns } from "./Succeed.vue?vue&type=template&id=6d42c922&scoped=true&"
import script from "./Succeed.vue?vue&type=script&lang=js&"
export * from "./Succeed.vue?vue&type=script&lang=js&"
import style0 from "./Succeed.vue?vue&type=style&index=0&id=6d42c922&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42c922",
  null
  
)

component.options.__file = "Succeed.vue"
export default component.exports